import { Grid } from "@mui/material";

import { TextField } from "../../../components";

export default function FormTwo({ formData, formikProps, editState }) {
  return (
    <Grid size={6}>
      <TextField
        disabled={!editState}
        size="small"
        label="Company Address"
        placeholder="Company Address"
        name="companyAddress"
        multiline
        formikProps={formikProps}
      />
    </Grid>
  );
}
